export default __webpack_public_path__ + "static/logo_sozo-niebieskie_pag-1c9bfe9feac3e8175477ce46a5af4557.jpg";